import Vue from 'vue';

const EventBus = new Vue();

export default {
  registerEvent(name, func) {
    EventBus.$on(name, func)
  },
  broadcast(name, param) {
    EventBus.$emit(name, param)
  }
}
